// extracted by mini-css-extract-plugin
export default {"box":"siteholder_box__UQHIi","black":"siteholder_black__CQhZV","white":"siteholder_white__JZDu5"};